import { BaseApi } from './base.api.js';

export class ComplianceObligationApi extends BaseApi {
    constructor(client) {
        super(client, '/compliance-obligation');
    }
}
